module.exports = __webpack_public_path__ + "img/23.e747c7f8.gif";